import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function NotFoundPage() {
  return (
    <>
      <Header />
      <main data-testid="not-found-page" style={{ paddingTop: 72, minHeight: '70vh', background: 'var(--bg-section)', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 24 }}>
        <div style={{ maxWidth: 520 }}>
          <p style={{ fontFamily: 'var(--font-mono)', fontSize: 12, color: 'var(--secondary-light, #EF5350)', letterSpacing: '0.25em', textTransform: 'uppercase', marginBottom: 12 }}>ERROR 404</p>
          <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 'clamp(40px, 6vw, 72px)', fontWeight: 700, color: 'var(--text-primary)', marginBottom: 12, letterSpacing: '-0.02em', lineHeight: 1 }}>Página não encontrada</h1>
          <p style={{ fontSize: 16, color: 'var(--text-secondary)', maxWidth: 460, margin: '0 auto 32px', lineHeight: 1.6 }}>
            A página que procura não existe ou foi movida. The page you're looking for doesn't exist.
          </p>
          <Link to="/" data-testid="back-home-btn"
            style={{ display: 'inline-block', padding: '14px 32px', background: '#0A1128', color: 'white', textDecoration: 'none', fontWeight: 700, fontSize: 13, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
            Voltar ao Início
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}
